/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { DepartmentsState } from '@departments/store/departments.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const selectDepartmentsState = createFeatureSelector<DepartmentsState>('departments');

export const getDepartments = createSelector(selectDepartmentsState, state => state.departments);
export const getCurrentDepartment = createSelector(selectDepartmentsState, state => state.currentDepartment);
export const getIsDepartmentActionPending = createSelector(selectDepartmentsState, state => state.isActionPending);

/** Die Abteilungen, die im Auswahlfeld des Personal-Dialogs stehen duerfen. */
export const getDriverDepartments = createSelector(
  getDepartments,
  departments => departments.filter(department => department.canHoldDrivers)
);

/** Die Abteilungen, die im Auswahlfeld des Fahrzeug-Dialogs stehen duerfen. */
export const getVehicleDepartments = createSelector(
  getDepartments,
  departments => departments.filter(department => department.canHoldVehicles)
);

/**
 * Vorschlag fuer die Reihenfolge einer neuen Abteilung: 10 hinter der letzten, damit
 * spaeteres Einsortieren dazwischen ohne Umnummerieren moeglich bleibt.
 */
export const getNextDepartmentSortOrder = createSelector(
  getDepartments,
  departments => departments.reduce((highest, department) => Math.max(highest, department.sortOrder), 0) + 10
);
